import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './fil-pull-out.styles.js';

/**
 * @tag fil-pull-out
 * @property {"primary"|"secondary"} [appearance='primary'] Appearance of the component
 * @property {string} [source] Source details of the component
 * @property {"standard" | "banner"} [variation="standard"] Variation of the component
 */
export class FilPullOut extends LitElement {
  static properties = {
    appearance: { type: String }, // 'primary' | 'secondary'
    source: { type: String },
    variation: { type: String }, // 'banner' | 'standard'
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.appearance = 'primary';
    this.variation = 'standard';
  }

  bodyTemplate() {
    const classes = {
      [`fil-pull-out--border__${this.appearance}`]: this.appearance !== 'primary',
    };

    return html`
      <div class="fil-pull-out__wrapper">
        <div class="fil-pull-out__content${classMap(classes)}">
          <p class="fil-pull-out__maintext"><slot></slot></p>
          ${this.source ? html`<p class="fil-pull-out__source">${this.source}</p>` : null}
        </div>
      </div>
    </div>
    `;
  }

  render() {
    const classes = {
      [`fil-pull-out--${this.variation}`]: this.variation !== 'standard',
      [`fil-pull-out--${this.variation}__${this.appearance}`]:
        this.variation !== 'standard' && this.appearance !== 'primary',
    };

    return html`<div class="fil-pull-out${classMap(classes)}">${this.bodyTemplate()}</div>`;
  }
}

export default FilPullOut;
